import React, { useEffect, useState } from "react";
import { Radio, Select, Tooltip } from "antd";
import "./style.css";
import {
  CustomLabel,
  accident_plainOptions,
  accident_typeOFCOVER,
  acide_plainOptions_forSelect,
  plainOptions,
  plainOptions_forSelect,
  typeOFCOVER,
  typeOfCal,
} from "../../Constant";
import { useDispatch, useSelector } from "react-redux";
import { onChangeCoverType } from "../../Redux/CIReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { constants } from "buffer";

const ff_content = `Earning Member - As per the Sum Insured opted
Non-earning Spouse - 60% of Sum Insured of Earning Member
Dependent Children - 30% of the Sum Insured of Earning Member
Dependent Parents/Parent-in-Laws or Dependent Siblings - 30% of the Sum Insured of Earning Member`
const ml_cotent = `All Insured member to be an earning member, Sum insured available max. up to 10 times of the income`

const TabComponent = ({ tab, setTab }) => {
  const isMobile = useIsMobile();
  const data = useSelector((state) => state.CI.coverType);
  const typeOfCalculator = useSelector((state) => state.common.type);

  const dispatch = useDispatch();
  const [toolTipContent, setToolTipContent] =
    useState(ff_content);
  useEffect(() => {
    if (data.toLowerCase().includes("family")) {
      setToolTipContent(ff_content);
    }else{
      setToolTipContent(ml_cotent)
    }
  }, [data]);

  return (
    <React.Fragment>
      <div className="row gy-2 mb-5">
        <div className="col-12" >
          <CustomLabel font_size="14">{"Select cover type"} &nbsp; &nbsp;</CustomLabel>
          
          <Tooltip title={toolTipContent}>
            <FontAwesomeIcon
              icon={faCircleInfo}
              style={{ color: "#0184c9", width: "13px" }}
            />
          </Tooltip>
        </div>
        <div className="col-12">
          {!isMobile ? (
            <Radio.Group
              className="tabs-cg"
              options={plainOptions}
              value={data.toLowerCase().includes("family") ? typeOFCOVER.ff : data}
              onChange={(e) => {
                dispatch(onChangeCoverType(e.target.value))}}
              optionType="button"
              buttonStyle="solid"
              size="large"
            />
          ) : (
            <Select
              options={plainOptions_forSelect}
               value={data}
              style={{
                width: 120,
              }}
              onChange={(e) => dispatch(onChangeCoverType(e))}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TabComponent;
